import { render, staticRenderFns } from "./EditorClips.vue?vue&type=template&id=44b2d37c"
import script from "./EditorClips.vue?vue&type=script&lang=js"
export * from "./EditorClips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports